module.exports = "/_next/static/images/48f18647ad4e08a57590740d922b3fa8-transfer-icon.svg.webp";